{
	"title": "Klantgroepen",
	"description": "Klantgroepen met hun standaardkorting, en de standaardstaffel van de shop.",
	"percent": "{{percent}}%",
	"groups": {
		"title": "Klantgroepen",
		"description": "Consument betaalt de consumentenprijs incl. btw. Een zakelijke groep krijgt zijn standaardkorting op de consumentenprijs excl. btw, op alle producten. Per product kun je een afwijkende korting geven.",
		"label": "Klantgroepen",
		"empty": "Er zijn nog geen zakelijke klantgroepen.",
		"fixed": "Vast",
		"fixedDescription": "Consument is de standaardgroep: altijd 0%, prijzen incl. btw.",
		"column": {
			"name": "Naam",
			"discount": "Standaardkorting",
			"basis": "Prijzen",
			"actions": "Acties"
		},
		"basis": {
			"inclVat": "Incl. btw",
			"exclVat": "Excl. btw"
		},
		"field": {
			"name": "Naam",
			"namePlaceholder": "Bijvoorbeeld Groothandel",
			"discount": "Standaardkorting (%)",
			"discountDescription": "Onder de consumentenprijs excl. btw, op alle producten."
		},
		"new": {
			"title": "Nieuwe klantgroep",
			"submit": "Klantgroep toevoegen"
		},
		"edit": {
			"button": "{{name}} bewerken",
			"title": "{{name}} bewerken",
			"save": "Opslaan",
			"cancel": "Annuleren"
		},
		"delete": {
			"button": "{{name}} verwijderen",
			"title": "Klantgroep {{name}} verwijderen?",
			"description": "De afwijkende kortingen die producten voor {{name}} hebben, verdwijnen ook. Dit kun je niet ongedaan maken.",
			"confirm": "Verwijderen"
		}
	},
	"shop": {
		"title": "Standaardstaffel van de shop",
		"description": "Geldt voor elk product dat op \"Standaard van de shop\" staat, voor alle klantgroepen, ook Consument. Laat leeg voor geen staffel.",
		"label": "Standaardstaffel van de shop"
	},
	"list": {
		"from": "Vanaf (stuks)",
		"percent": "Korting (%)",
		"step": "Stap {{number}}",
		"stepFrom": "Stap {{number}}: vanaf",
		"stepPercent": "Stap {{number}}: korting",
		"add": "Stap toevoegen",
		"remove": "Stap {{number}} weghalen",
		"empty": "Geen stappen: geen staffelkorting.",
		"hint": "Een staffel begint bij 2 stuks. Hoogstens 15 stappen; de volgorde regelen we zelf.",
		"summaryStep": "vanaf {{minQuantity}} −{{percent}}%",
		"none": "geen staffel",
		"error": {
			"incomplete": "Vul bij stap {{number}} het aantal en de korting in.",
			"minQuantity": "Een staffel begint bij 2 stuks (stap {{number}}).",
			"percent": "Geef bij stap {{number}} een korting van 1 tot 99%.",
			"duplicate": "Het aantal {{minQuantity}} staat er twee keer in.",
			"tooMany": "Hoogstens 15 stappen.",
			"required": "Houd minstens één stap over."
		}
	},
	"card": {
		"title": "Prijzen",
		"description": "Kortingen bovenop de consumentenprijs. Standaard volgt dit product de klantgroepen en de staffel van de shop.",
		"groups": "Klantgroepen",
		"groupsEmpty": "Er zijn nog geen zakelijke klantgroepen. Maak ze aan bij Instellingen → Klantgroepen.",
		"groupsLink": "Klantgroepen beheren",
		"groupDefault": "Standaard −{{percent}}%",
		"deviate": "Afwijken voor dit product",
		"deviateLabel": "{{name}}: afwijken voor dit product",
		"ownPercent": "Korting voor {{name}} op dit product (%)",
		"percentError": "Vul een heel percentage van 0 tot 100 in.",
		"quantity": "Staffelkorting",
		"quantityDescription": "Geldt voor alle varianten en alle klantgroepen, ook Consument.",
		"mode": {
			"shop": "Standaard van de shop",
			"own": "Eigen staffel",
			"none": "Geen staffel"
		},
		"shopList": "De shop geeft nu: {{list}}.",
		"shopLink": "Standaardstaffel aanpassen",
		"noneDescription": "Ook de standaardstaffel van de shop geldt niet voor dit product.",
		"ownLabel": "Eigen staffel van dit product",
		"variantExceptions_one": "{{count}} variant heeft een afwijkende staffel (zie het zijpaneel van de variant).",
		"variantExceptions_other": "{{count}} varianten hebben een afwijkende staffel (zie het zijpaneel van elke variant)."
	},
	"check": {
		"title": "Prijscheck",
		"description": "Wat betaalt een klantgroep voor een variant bij een aantal?",
		"consumer": "Consument",
		"group": "Klantgroep",
		"variant": "Variant",
		"quantity": "Aantal",
		"unitPrice": "Per stuk",
		"lineTotal": "Totaal",
		"basis": {
			"inclVat": "incl. btw",
			"exclVat": "excl. btw"
		},
		"amount": "{{amount}} {{basis}}",
		"loading": "Prijs berekenen…",
		"failed": "De prijs kon niet worden berekend.",
		"quantityError": "Vul een aantal van 1 of meer in."
	},
	"applied": {
		"consumerPriceOnly": "Consumentenprijs, geen korting",
		"customerPrice": "Klantprijs (vast)",
		"groupDiscount": "{{name}} −{{percent}}%",
		"groupDiscountProduct": "{{name}} −{{percent}}% (afwijkend voor dit product)",
		"quantityDiscount": "staffel vanaf {{minQuantity}} −{{percent}}%",
		"quantityDiscountProduct": "eigen staffel vanaf {{minQuantity}} −{{percent}}%",
		"quantityDiscountVariant": "staffel van deze variant vanaf {{minQuantity}} −{{percent}}%",
		"separator": " · "
	},
	"variant": {
		"title": "Afwijkende staffel",
		"switch": "Afwijkende staffel voor deze variant",
		"follows": "Volgt het product: {{list}}.",
		"label": "Staffel van {{variant}}",
		"removed": "De afwijkende staffel van {{variant}} is weg.",
		"description": "Vervangt de staffel van het product, alleen voor deze variant."
	},
	"error": {
		"nameTaken": "Een andere klantgroep heeft deze naam al.",
		"consumerFixed": "Consument ligt vast: 0%, prijzen incl. btw.",
		"notFound": "Deze klantgroep bestaat niet (meer)."
	},
	"help": {
		"pricing": {
			"title": "Prijzen",
			"area": "Producten › Prijzen",
			"short": "Wat dit product doet bovenop de consumentenprijs: een afwijkende korting per klantgroep en een staffelkorting. De prijscheck rekent uit wat een klant betaalt.",
			"terms": ["price:consumerPrice", "price:groupDiscount", "price:quantityDiscount", "price:priceCheck"]
		},
		"consumerPrice": {
			"title": "Consumentenprijs",
			"area": "Producten › Basis",
			"short": "De prijs incl. btw die een consument betaalt. Elke klantgroep rekent vanaf deze prijs: een zakelijke groep krijgt zijn korting op de prijs excl. btw.",
			"terms": ["price:customerGroup", "price:quantityDiscount"]
		},
		"groupDiscount": {
			"title": "Afwijkende korting",
			"area": "Producten › Prijzen",
			"short": "Een zakelijke klantgroep krijgt zijn standaardkorting op alle producten. Wil je voor dit product een andere korting voor een groep, zet dan Afwijken aan en vul het percentage in.",
			"warning": "Een afwijkende korting geldt voor alle varianten van dit product. Per variant kan het niet.",
			"terms": ["price:customerGroup"],
			"goTo": {
				"to": "/settings/customer-group",
				"label": "Naar Klantgroepen"
			}
		},
		"quantityDiscount": {
			"title": "Staffelkorting",
			"area": "Producten › Prijzen",
			"short": "Korting als een klant meer pakken tegelijk koopt. Bijvoorbeeld: vanaf 3 pakken 5% korting, vanaf 10 pakken 10%.",
			"choices": [
				{
					"name": "Standaard van de shop",
					"text": "Dit product volgt de standaardstaffel van de shop."
				},
				{
					"name": "Eigen staffel",
					"text": "Alleen voor dit product. Je kiest zelf de stappen."
				},
				{
					"name": "Geen staffel",
					"text": "Nooit staffelkorting op dit product."
				}
			],
			"warning": "Geldt voor elke klantgroep, ook Consument, bovenop hun prijs. Een vaste klantprijs krijgt nooit staffelkorting.",
			"terms": ["price:customerGroup", "customer:customerPrice", "price:shopQuantityDiscount"],
			"goTo": {
				"to": "/settings/customer-group",
				"label": "Standaardstaffel aanpassen"
			}
		},
		"customerGroup": {
			"title": "Klantgroep",
			"area": "Instellingen › Klantgroepen",
			"short": "Consument, of een zakelijke groep met een standaardkorting op alle producten. Elke zakelijke klant zit in één groep.",
			"choices": [
				{
					"name": "Consument",
					"text": "Vast. Betaalt de consumentenprijs en ziet prijzen incl. btw."
				},
				{
					"name": "Zakelijke groep",
					"text": "Krijgt zijn standaardkorting op de consumentenprijs excl. btw, en ziet prijzen standaard excl. btw. Een klant kan in zijn account incl. btw kiezen."
				}
			],
			"terms": ["price:defaultDiscount", "price:deleteCustomerGroup"],
			"goTo": {
				"to": "/settings/customer-group",
				"label": "Naar Klantgroepen"
			}
		},
		"shopQuantityDiscount": {
			"title": "Standaardstaffel van de shop",
			"area": "Instellingen › Klantgroepen",
			"short": "De staffel voor elk product dat op \"Standaard van de shop\" staat. Pas je hem aan, dan verandert hij voor al die producten.",
			"terms": ["price:quantityDiscount"],
			"goTo": {
				"to": "/settings/customer-group",
				"label": "Naar Klantgroepen"
			}
		},
		"priceCheck": {
			"title": "Prijscheck",
			"area": "Producten › Prijzen",
			"short": "Reken na wat een klant betaalt: kies een klantgroep, een variant en een aantal. Je ziet de prijs per stuk, het totaal en welke korting er geldt.",
			"warning": "Een klantprijs van één klant zit er niet in: die gaat altijd voor, zonder staffelkorting.",
			"terms": ["customer:customerPrice", "price:quantityDiscount"]
		},
		"variantQuantityDiscount": {
			"title": "Afwijkende staffel",
			"area": "Producten › Varianten",
			"short": "Een eigen staffel voor één variant. Die vervangt voor deze variant de staffel van het product. Zet je hem uit, dan volgt de variant het product weer.",
			"terms": ["price:quantityDiscount"]
		},
		"defaultDiscount": {
			"title": "Standaardkorting",
			"area": "Instellingen › Klantgroepen",
			"short": "Het percentage dat een zakelijke groep krijgt onder de consumentenprijs excl. btw, op alle producten. Wil je voor één product een andere korting, geef dan bij dat product een afwijkende korting.",
			"warning": "Staffelkorting komt er nog bovenop. Een vaste klantprijs gaat altijd voor, zonder korting erbij.",
			"terms": ["price:groupDiscount", "price:quantityDiscount", "customer:customerPrice"]
		},
		"deleteCustomerGroup": {
			"title": "Klantgroep verwijderen",
			"area": "Instellingen › Klantgroepen",
			"short": "Een lege groep verdwijnt meteen. Zitten er klanten in, dan kies je de zakelijke groep waar ze naartoe gaan. De afwijkende kortingen en verzendregels van deze groep verdwijnen ook.",
			"warning": "Is een kortingscode beperkt tot deze groep, dan kan het niet: haal de groep eerst uit die code. Consument kun je nooit verwijderen.",
			"terms": ["price:groupDiscount"]
		}
	},
	"helpExample": {
		"quantityDiscount": {
			"steps": {
				"choose": "Kies Eigen staffel",
				"first": "Vul de eerste stap in: vanaf 3, 5%",
				"add": "Voeg een stap toe: vanaf 10, 10%",
				"saved": "Het slaat zichzelf op",
				"shop": "De shop toont de stappen onder de prijs"
			},
			"animation": "Animatie: je kiest Eigen staffel, vult vanaf 3 stuks 5% in, voegt vanaf 10 stuks 10% toe, en de shop toont die stappen onder de prijs.",
			"sandbox": "Kies de staffel en het aantal pakken, en kijk wat de klant ziet.",
			"mode": "Staffel in het voorbeeld",
			"quantity": "Aantal pakken",
			"less": "Een pak minder",
			"more": "Een pak meer",
			"shopLabel_one": "Voorbeeld uit de shop: Floorwipes XXL, 20 doekjes, €8,95, bij {{count}} pak. {{staffel}} Op de knop: {{button}}.",
			"shopLabel_other": "Voorbeeld uit de shop: Floorwipes XXL, 20 doekjes, €8,95, bij {{count}} pakken. {{staffel}} Op de knop: {{button}}.",
			"noStaffel": "Geen staffel.",
			"product": "Floorwipes XXL",
			"variant": "20 doekjes"
		}
	}
}
